import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { CreativeContext } from "./CreativeCreation";

// Widget: image, pooja name, description, amount, pooja date, pooja place, button
function Vedamandir({
  company,
  companyName,
  handleshow,
  creative_name,
  creative_type,
  subtype,
  editdata,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const navigate = useNavigate();
  const { setPreview } = useContext(CreativeContext);

  const [image, setImage] = useState("");
  const [imgurl, setImgurl] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  const watchPoojaName = watch("poojaName", editdata?.pooja_name || "");
  const watchDescription = watch("description", editdata?.description || "");
  const watchAmount = watch("amount", editdata?.amount || "");
  const watchPoojaDate = watch("poojaDate", editdata?.pooja_date || "");
  const watchPoojaPlace = watch("poojaPlace", editdata?.pooja_place || "");
  const watchButtonEnabled = watch(
    "buttonEnabled",
    editdata?.button_enabled === 1 ? true : false
  );
  const watchButtonType = watch("buttonType", editdata?.button_type || "call");
  const watchButtonText = watch("buttonText", editdata?.button_text || "");
  const watchPhone = watch("phone", editdata?.button_link || "");
  const watchChatUrl = watch("chatUrl", editdata?.button_link || "");
  const watchRedirectUrl = watch("redirectUrl", editdata?.button_link || "");

  useEffect(() => {
    setPreview(prev => ({
      ...prev,
      sub_type: "vedamandir",
      pooja_name: watchPoojaName,
      description: watchDescription,
      amount: watchAmount,
      pooja_date: watchPoojaDate,
      pooja_place: watchPoojaPlace,
      button_enabled: watchButtonEnabled,
      button_type: watchButtonType,
      button_text: watchButtonText,
      button_link:
        watchButtonType === "call"
          ? watchPhone
          : watchButtonType === "chat"
          ? watchChatUrl
          : watchRedirectUrl,
    }));
  }, [
    watchPoojaName,
    watchDescription,
    watchAmount,
    watchPoojaDate,
    watchPoojaPlace,
    watchButtonEnabled,
    watchButtonType,
    watchButtonText,
    watchPhone,
    watchChatUrl,
    watchRedirectUrl,
    setPreview,
  ]);

  useEffect(() => {
    if (flag === "edit") {
      setPreview(prev => ({
        ...prev,
        sub_type: editdata?.sub_type || "vedamandir",
        img_urls: editdata?.img_urls || "",
      }));
      setImgurl(editdata?.img_urls || "");
    }
  }, [flag, editdata, setPreview]);

  const handleImage = (e) => {
    try {
      if (e.target.files && e.target.files.length > 0) {
        const file = e.target.files[0];
        if (
          file.type === "image/jpg" ||
          file.type === "image/jpeg" ||
          file.type === "image/webp" ||
          file.type === "image/png"
        ) {
          setImage(file);
        } else {
          Toast("error", "Only jpg, jpeg, webp, png formats accepted");
          setValue("image", "");
        }
      } else if (flag === "edit") {
        setImgurl(editdata?.img_urls || "");
        setPreview(prev => ({ ...prev, img_urls: editdata?.img_urls || "" }));
      } else {
        setImgurl("");
        setPreview(prev => ({ ...prev, img_urls: "" }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formData = new FormData();
  formData.append("files", image);

  const uploadImage = async () => {
    try {
      const res = await api({
        url: `/upload/brandImage`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res?.code === 200) {
        setImgurl(res?.data?.data);
        setPreview(prev => ({ ...prev, img_urls: res?.data?.data }));
      } else {
        setValue("image", null);
        setImage("");
        Toast("error", res?.data?.message || "Image upload failed");
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (image) uploadImage();
  }, [image]);

  const buildButtonLink = (data) => {
    if (!data.buttonEnabled) return "";
    if (data.buttonType === "call") return data.phone || "";
    if (data.buttonType === "chat") return data.chatUrl || "";
    return data.redirectUrl || "";
  };

  const onSubmit = async (data) => {
    if (flag === "add") {
      handlesubmit(true);
      const obj = {
        company_id: company,
        company_name: companyName,
        creative_name,
        creative_type,
        sub_type: subtype,
        pooja_name: data.poojaName,
        description: data.description,
        amount: data.amount,
        pooja_date: data.poojaDate,
        pooja_place: data.poojaPlace,
        img_url: imgurl,
        button_enabled: data.buttonEnabled ? true : false,
        button_type: data.buttonEnabled ? data.buttonType : "",
        button_text: data.buttonEnabled ? data.buttonText : "",
        button_link: data.buttonEnabled ? buildButtonLink(data) : "",
      };
      if (creative_name !== "") {
        try {
          const res = await api({
            url: `/creatives/widget/vedamandir`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res?.data?.message || "Create failed");
          }
        } catch (error) {
          console.error(error);
          if (error.response?.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      const obj = {
        creative_id: editdata?.creative_id,
        creative_name: creative_name,
        pooja_name: data.poojaName,
        description: data.description,
        amount: data.amount,
        pooja_date: data.poojaDate,
        pooja_place: data.poojaPlace,
        button_enabled: data.buttonEnabled ? true : false,
        button_type: data.buttonEnabled ? data.buttonType : "",
        button_text: data.buttonEnabled ? data.buttonText : "",
        button_link: data.buttonEnabled ? buildButtonLink(data) : "",
      };
      obj.img_url = imgurl !== "" ? imgurl : editdata?.img_urls;
      try {
        const res = await api({
          url: `/creatives/widget/editvedamandir`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          handleshow(false);
          createdEdited(true);
        } else {
          Toast("error", res?.data?.message || "Edit failed");
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status === 401) navigate("/");
      }
    }
  };

  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <div className="row">
          <section className="col-12">
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Pooja Name</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.pooja_name || ""}
                  placeholder="Enter pooja name"
                  {...register("poojaName", { required: "Pooja name is required" })}
                />
                {errors.poojaName && (
                  <p className="text-red-600">{errors.poojaName.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  rows="3"
                  defaultValue={editdata?.description || ""}
                  placeholder="Enter description"
                  {...register("description", {
                    required: "Description is required",
                  })}
                />
                {errors.description && (
                  <p className="text-red-600">{errors.description.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Amount</label>
                <input
                  type="number"
                  className="form-control"
                  defaultValue={editdata?.amount || ""}
                  placeholder="Enter amount"
                  {...register("amount", {
                    required: "Amount is required",
                    min: { value: 1, message: "Minimum amount is 1" },
                  })}
                />
                {errors.amount && (
                  <p className="text-red-600">{errors.amount.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Pooja Date</label>
                <input
                  type="date"
                  className="form-control"
                  defaultValue={editdata?.pooja_date || ""}
                  {...register("poojaDate", { required: "Pooja date is required" })}
                />
                {errors.poojaDate && (
                  <p className="text-red-600">{errors.poojaDate.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Pooja Place</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={editdata?.pooja_place || ""}
                  placeholder="Enter pooja place"
                  {...register("poojaPlace", {
                    required: "Pooja place is required",
                  })}
                />
                {errors.poojaPlace && (
                  <p className="text-red-600">{errors.poojaPlace.message}</p>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Upload Image</label>
                <input
                  type="file"
                  className="form-control"
                  {...register("image", {
                    required: editdata?.img_urls ? false : true,
                    onChange: (e) => handleImage(e),
                  })}
                />
                {!editdata?.img_urls && errors.image && (
                  <p className="text-red-600">Image is required</p>
                )}
                <p>{imgurl || editdata?.img_urls}</p>
              </div>
            </div>

            <div className="row mb-2">
              <div className="col">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    defaultChecked={
                      editdata?.button_enabled === 1 ? true : false
                    }
                    {...register("buttonEnabled")}
                  />
                  <label className="form-check-label">Enable Button</label>
                </div>
              </div>
            </div>

            {watchButtonEnabled && (
              <>
                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Button Type</label>
                    <select
                      className="form-control"
                      defaultValue={editdata?.button_type || "call"}
                      {...register("buttonType", {
                        required: "Button type is required",
                      })}
                    >
                      <option value="call">Call</option>
                      <option value="chat">Chat</option>
                      <option value="redirect">Redirect</option>
                    </select>
                    {errors.buttonType && (
                      <p className="text-red-600">{errors.buttonType.message}</p>
                    )}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col">
                    <label className="form-label">Button Text</label>
                    <input
                      type="text"
                      className="form-control"
                      defaultValue={editdata?.button_text || ""}
                      placeholder="Enter button text"
                      {...register("buttonText", {
                        required: "Button text is required",
                      })}
                    />
                    {errors.buttonText && (
                      <p className="text-red-600">{errors.buttonText.message}</p>
                    )}
                  </div>
                </div>

                {watchButtonType === "call" && (
                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata?.button_link || ""}
                        placeholder="Enter phone number"
                        {...register("phone", {
                          required: "Phone number is required",
                          pattern: {
                            value: /^(0\d{10}|[6-9]\d{9})$/,
                            message: "Enter a valid phone number",
                          },
                        })}
                      />
                      {errors.phone && (
                        <p className="text-red-600">{errors.phone.message}</p>
                      )}
                    </div>
                  </div>
                )}

                {watchButtonType === "chat" && (
                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Chat URL</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata?.button_link || ""}
                        placeholder="Enter chat URL"
                        {...register("chatUrl", {
                          required: "Chat URL is required",
                          pattern: {
                            value:
                              /^(https?:\/\/)?([\w.-]+)\.[a-z]{2,6}(\/[\w\-./?=&%]*)?$/i,
                            message: "Enter a valid URL",
                          },
                        })}
                      />
                      {errors.chatUrl && (
                        <p className="text-red-600">{errors.chatUrl.message}</p>
                      )}
                    </div>
                  </div>
                )}

                {watchButtonType === "redirect" && (
                  <div className="row mb-3">
                    <div className="col">
                      <label className="form-label">Redirect URL</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata?.button_link || ""}
                        placeholder="Enter redirect URL"
                        {...register("redirectUrl", {
                          required: "Redirect URL is required",
                          pattern: {
                            value:
                              /^(https?:\/\/)?([\w.-]+)\.[a-z]{2,6}(\/[\w\-./?=&%]*)?$/i,
                            message: "Enter a valid URL",
                          },
                        })}
                      />
                      {errors.redirectUrl && (
                        <p className="text-red-600">{errors.redirectUrl.message}</p>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="my-3 text-end">
              <button type="submit" className="btn btn-primary">
                Save Creative
              </button>
            </div>
          </section>
        </div>
      </form>
    </div>
  );
}

export default Vedamandir;
